(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = [
    ...document.querySelectorAll('[data-journey-reveal]'),
    ...document.querySelectorAll('[id$="__guatemala_images"] .media-grid__item')
  ];

  if (revealItems.length === 0) return;

  revealItems.forEach((item) => item.setAttribute('data-journey-reveal', item.dataset.journeyReveal || 'stagger'));

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  revealItems.forEach((item) => observer.observe(item));
})();
